<button class="no-style color-picker-container" (click)="openColorPicker($event, field.value)">
    <mat-icon svgIcon="drop-custom" class="color-icon" [style.color]="field.value"></mat-icon>
    <span class="name">{{field.name}}</span>
    <span class="change" trans>Change</span>
</button>